<div class="d-flex flex-row align-items-center flex-1">
  <span class="italic d-inline-flex w-25" *ngIf="to.resourceId || to.label">{{
    to.resourceId ? (to.resourceId | apmTranslate) : to.label
  }}</span>
  <div class="d-flex flex-row align-items-center justify-content-start flex-1" *ngFor="let field of field.fieldGroup">
    <formly-field class="flex-1" [field]="field"></formly-field>
  </div>
</div>
